import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FlyoutLangSelectorExtendedComponent } from './flyout-langselector-extended.component';

import {
  Code,
  CountryLanguages,
  FlyoutLangSelector,
  LanguageDetails,
  RegionData,
  RegionList
} from './models/flyout-langselector.interface';

@Component({
  selector: 'idp-lang-selector',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './flyout-langselector.component.html',
  styleUrls: ['./flyout-langselector.component.scss']
})
export class FlyoutLangSelectorComponent
  extends FlyoutLangSelectorExtendedComponent
  implements AfterViewInit
{
  @Input() content: FlyoutLangSelector = {} as FlyoutLangSelector;
  @Input() searchList!: CountryLanguages[] | null;
  @Output() displayContentLanguageEvent = new EventEmitter();
  @Output() searchValueChangeEvent = new EventEmitter<string>();
  @Output() afterLanguageSelectedEvent = new EventEmitter<Code>();
  @Output() languageSelectionAnalyticsEvent = new EventEmitter<HTMLElement>();
  @Output() closeEvent = new EventEmitter();
  @Output() regionClicked = new EventEmitter<RegionData>();
  @Input() showModal!: boolean | null;
  @ViewChild('searchField') searchField!: ElementRef;
  show!: boolean;
  regionSelected = false;
  isRegionSelected!: number;
  searchValue!: string;
  activeIndex: number | null = null;

  ngAfterViewInit(): void {
    this.focusToInput();
  }

  close() {
    this.setHTMLOverflow();
    this.clearSearchField();
    this.closeEvent.emit();
  }

  sortOptionsLanguage: {
    descending: boolean;
    exceptionValue: string;
  } = {
    descending: false,
    exceptionValue: 'en'
  };

  sortCountries(selectedRegionCountries: CountryLanguages[] | null) {
    if (selectedRegionCountries && selectedRegionCountries.length > 0) {
      selectedRegionCountries.sort((a, b) => {
        const aValue = a.countryName;
        const bValue = b.countryName;
        return this.sortProperties(aValue, bValue);
      });
    }
    return selectedRegionCountries;
  }

  sortLanguages(languageDetails: LanguageDetails[]) {
    const { descending, exceptionValue } = this.sortOptionsLanguage;
    if (!languageDetails) return languageDetails;
    const order = descending ? -1 : 1;
    return languageDetails.sort((a, b) => {
      if (b.languageCode !== a.languageCode) {
        if (a.languageCode === exceptionValue) {
          return -1 * order;
        } else if (b.languageCode === exceptionValue) {
          return 1 * order;
        }
      }
      return 0;
    });
  }

  displayContentLanguage(content: string) {
    this.displayContentLanguageEvent.emit(content);
  }

  onSearchValueChanged(selectedValue: string) {
    this.searchValueChangeEvent.emit(selectedValue);
  }

  clearSearchField() {
    this.searchValue = '';
    if (this.searchField?.nativeElement?.focus) {
      this.searchField.nativeElement.focus();
    }
  }

  afterLanguageSelected(langCode: string, isoCode: string, event?: Event) {
    if (event?.currentTarget) {
      this.languageSelectionAnalyticsEvent.emit(
        event.currentTarget as HTMLElement
      );
    }
    if (isPlatformBrowser(this.platformId)) {
      this.setHTMLOverflow();
      const code: Code = {
        languageCode: langCode,
        countryCode: isoCode
      };
      this.afterLanguageSelectedEvent.emit(code);
    }
  }

  onRegionClicked(region: RegionList, count: number, mobileFlow?: boolean) {
    this.show = !this.show;
    if (mobileFlow) {
      this.activeIndex = this.activeIndex === count ? null : count;
    }
    const flow = 'event';
    this.regionClicked.emit({ region, flow, count });
    this.scrollToTop();
  }
}
